var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card box-shadow text-white bg-primary" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "my-0 font-weight-normal" }, [
        _vm._v(_vm._s(_vm.params.title))
      ])
    ]),
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _c("h1", { staticClass: "card-title pricing-card-title" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.params.price.currency) +
              _vm._s(_vm.params.price.value) +
              "\n            "
          ),
          _vm.params.price.hint
            ? _c("small", [_vm._v(_vm._s(_vm.params.price.hint))])
            : _vm._e()
        ]),
        _c(
          "ul",
          { staticClass: "list-unstyled mt-3 mb-4" },
          _vm._l(_vm.params.lines, function(line, index) {
            return _c("li", { key: index }, [_vm._v(_vm._s(line))])
          }),
          0
        ),
        _c(
          "nuxt-link",
          {
            staticClass: "btn btn-lg btn-block btn-outline-light",
            attrs: {
              to: {
                name: "lang-payment-package-id",
                params: { lang: _vm.lang, id: _vm.paymentPackage.id }
              }
            }
          },
          [_vm._v(_vm._s(_vm.params.link.title))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7a7b78c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7a7b78c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/templets/primary.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e7a7b78c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/templets/primary.vue
// module chunks = 14